<template>

    <div class="flex relative flex-col flex-1 justify-center items-center w-full md:w-11/12 p-4">

        <p v-text="info" v-if="info" class="xbg-green-300 xtext-white self-stretch text-center mb-10"></p>

        <div class="flex relative items-center w-full md:w-1/2 xl:w-1/3" v-if="showLink">
            <input type="text" id="link" class="w-full text-center border border-black border-r-0 rounded-l-lg py-1 px-4 focus:outline-none" v-model="currentLocation" >
            <button v-on:click="copyToClipboard" class="border border-black p-1 rounded-r-lg">
                Copy
            </button>
        </div>

        <button
            v-on:click="connect"
            v-if="!isDialling && !isConnected"
            class="bg-black xbg-green-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none">

            Vytvoriť nový tunel
        </button>

        <img :src="qrUrl" v-if="qrUrl && showLink">

        <div
            v-if="magiccode && isConnected"

            class="flex relative flex-col w-full h-full xbg-green-200 p-4 xl:p-10 border-2 border-dashed xborder-green-600"
            style="min-height: 50vh;"
            @drop.prevent="drop"
            @dragover.prevent
        >


            <label id="filepicker-wrap"
                class="self-center bg-black focus:bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 mb-4 rounded cursor-pointer focus:outline-none">
                <input type="file" id="filepicker" class="hidden" multiple @change="drop">
                Vybrať súbory
            </label>

            <div v-for="f in files" v-bind:key="f.id" class="">
                <div class="mt-2">
                    <span class="lnr lnr-enter-down" v-if="f.receiving"></span>
                    <span class="lnr lnr-exit-up" v-if="f.sending"></span>

                    {{ f.file.name }}

                    <div class="w-full h-2 bg-white border border-black">
                        <div class="h-full bg-black transition-all duration-500 ease-in-out" v-bind:style="{ width: f.progress + '%' }"></div>
                    </div>
                    <div class="flex justify-between">
                        <div>{{ humanFileSize(f.file.size) }}</div>
                        <div>{{ f.progress + '%' }}</div>
                    </div>

                </div>
            </div>

            <div class="absolute text-sm opacity-50 bottom-0 right-0 m-2" :class="{'text-green-500': connectionType != 'relay', 'text-gray-500': connectionType == 'relay'}">
                {{formatConnectionType}}
            </div>

        </div>

        <v-dialog />

    </div>

</template>

<script>

/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-constant-condition */

import { newwormhole, dial } from '@/assets/js/dial.js';
import { genpassword } from '@/assets/js/wordlist.js';
import { DataChannelWriter } from '@/assets/js/dataio'
import { getConnectionType } from '@/assets/js/webrtc';

export default {
    name: 'Wormhole',

    components: { },

    metaInfo: {
        title: 'Tunel',
    },

    data: () => {
        return {
            pc: null, // WebRTC Peer Connection
            connectionType: null,
            magiccode: null,
            datachannel: null,
            receiving: false,
            sending: null,
            files: [],
            queue: [], // sending queue
            queueWorking: false,
            debug: false,
            info: '',
            qrUrl: null,
            isDialling: false,
            isConnected: false,
            showLink: false,
            currentLocation: '',
            serviceworker: null,
            hacks: {},
            signalServer: process.env.VUE_APP_SIGNAL_SERVER,
        }
    },

    props: {

    },

    mounted() {

        this.magiccode = this.$route.params.magicCode

        this.connect()
    },

    computed: {
        formatConnectionType() {

            switch (this.connectionType) {
                case 'host':
                    return 'Priame spojenie (LAN)'
                case 'srflx':
                case 'prflx':
                    return 'Priame spojenie (STUN)'
                case 'relay':
                    return 'Nepriame spojenie (TURN)'
                default:
                    return ''
            }
        }
    },

    methods: {

        initPeerConnection(iceServers) {

          let normalisedICEServers = []
          for (let i=0; i<iceServers.length; i++) {
            normalisedICEServers.push({
              urls: iceServers[i].URLs,
              username: iceServers[i].Username,
              credential: iceServers[i].Credential
            })
          }
          this.pc = new RTCPeerConnection({
            iceServers: normalisedICEServers
          })
          this.pc.onconnectionstatechange = e => {
            switch (this.pc.connectionState) {
              case 'connected':
              // Handled in datachannel.onopen.
                console.log('webrtc connected')
                break
              case 'failed':
                this.disconnected()
                console.log('webrtc connection failed connectionState:', this.pc.connectionState, 'iceConnectionState', this.pc.iceConnectionState)

                this.info = 'Chyba spojenia, skús znova..'
                break
              case 'disconnected':
              case 'closed':
                this.disconnected()
                console.log('webrtc connection closed')
                this.info = 'Odpojené'
                this.pc.onconnectionstatechange = null
                break
            }
          }
          this.datachannel = this.pc.createDataChannel('data', { negotiated: true, id: 0 })
          this.datachannel.onopen = this.connected
          this.datachannel.onmessage = this.receive
          this.datachannel.binaryType = 'arraybuffer'
          this.datachannel.onclose = e => {
            this.disconnected()
            console.log('datachannel closed')
            this.info = 'Odpojené'
          }
          this.datachannel.onerror = e => {
            this.disconnected()
            console.log('datachannel error:', e.error)
            this.info = 'Chyba spojenia, skús znova..'
          }
          return this.pc
        },


        async connect() {

            this.browserhacks()

            console.log('connecting')

            this.info = 'Pripájam sa..'
            this.isDialling = true;

            // await goready;
            await Promise.all([this.swready(), this.wasmready()])


            if (this.hacks.browserunsupported) {
                this.info = 'Tento prehliadač nepodporuje potrebné technológie - WebSockets, WebRTC a WebAssembly.'
                return
            }

            try {
                if (this.magiccode == null) {


                    const [code, finish] = await newwormhole(this.signalServer, this.initPeerConnection)

                    this.info = 'Čaká sa na druhú stranu - odošli odkaz alebo načítaj kód mobilom:';

                    this.magiccode = code

                    this.$router.replace({ name: 'tunel', params: { magicCode: code } })
                    this.showLink = true

                    this.trackEvent('Connection', 'init', 'Init Connection', code.split('-')[0])

                    if (this.debug) {
                        window.open(location, '_blank');
                    }


                    await finish;
                } else {

                    if (this.hacks.noautoconnect == true)
                        return;

                    this.info = 'Pripájam sa..'

                    this.trackEvent('Connection', 'connect', 'Connecting to opened slot', this.magiccode.split('-')[0])

                    await dial(this.signalServer, this.magiccode, this.initPeerConnection);
                }
            } catch (err) {
                this.disconnected();
                console.log(err)
                if (err == "bad key") {
                    this.info = 'Chybný kľúč, skús znova..'
                } else if (err == "session ended") {
                    this.info = 'Druhá strana sa odpojila.'
                } else if (err == "no such slot") {
                    this.info = 'Tento tunel už neexistuje.'
                } else {
                    this.info = 'Chyba spojenia, skús znova..'
                }
            }

        },

    async send(f, index) {

            console.log(f);

            if (this.sending != null) {
                console.log("haven't finished this.sending", this.sending.name);
                return
            }

            this.datachannel.send(new TextEncoder('utf8').encode(JSON.stringify({
                name: f.name,
                size: f.size,
                type: f.type,
            })));

            this.sending = {f};
            this.sending.offset = 0;

            let writer = new DataChannelWriter(this.datachannel);
            if (!f.stream) {
                // Hack around safari's lack of Blob.stream() and arrayBuffer().
                // This is unbenchmarked and could probably be made better.
                let read = b => {
                    return new Promise(r => {
                        let fr = new FileReader();
                        fr.onload = (e) => {
                            r(new Uint8Array(e.target.result));
                        };
                        fr.readAsArrayBuffer(b);
                    });
                };
                const chunksize = 64<<10;
                while (this.sending.offset < f.size) {
                    let end = this.sending.offset+chunksize
                    if (end > f.size) {
                        end = f.size;
                    }
                    await writer.write(await read(f.slice(this.sending.offset, end)));
                    this.sending.offset = end;
                    this.sending.progress = this.sending.offset / f.size;
                }
            } else {
                let reader = f.stream().getReader();
                while (true) {
                    let { done, value } = await reader.read();
                    if (done) {
                        break;
                    }
                    await writer.write(value);

                    this.sending.offset += value.length;

                    // update upload indicator progress
                    this.files[index].offset = this.sending.offset;
                    this.files[index].progress = Math.round(100 * this.sending.offset / f.size);
                }
            }

            this.trackEvent('File', 'sent', 'File sent (kB)', Math.round(f.size / 10**3) );

            this.sending = null;
            console.log("file sent: "+f.name);
        },

        receive(e) {

            console.log("receiving"+e)

            if (!this.receiving) {

                this.receiving = JSON.parse(new TextDecoder('utf8').decode(e.data));
                this.receiving.id = Math.random().toString(16).substring(2) + '-' + encodeURIComponent(this.receiving.name)

                this.receiving.offset = 0;
                this.receiving.a = document.createElement('a')

                if (!this.serviceworker) {
                    this.receiving.data = new Uint8Array(this.receiving.size)
                }

                const length = this.files.push({
                    file: {
                        name: this.receiving.name,
                        // size: 0,
                    },
                    receiving: true,
                    offset: 0,
                    progress: 0,
                })
                this.receiving.index = length-1;

                if (this.serviceworker) {
                  this.serviceworker.postMessage({
                    id: this.receiving.id,
                    type: 'metadata',
                    name: this.receiving.name,
                    size: this.receiving.size,
                    filetype: this.receiving.type
                  })
                  this.triggerDownload(this.receiving)
                }

                return
            }

            const chunkSize = e.data.byteLength

            if (this.receiving.offset + chunkSize > this.receiving.size) {
                throw "received more bytes than expected";
            }

            if (this.serviceworker) {
                this.serviceworker.postMessage(
                {
                    id: this.receiving.id,
                    type: 'data',
                    data: e.data,
                    offset: this.receiving.offset
                },
                    [e.data]
                )
            } else {
                this.receiving.data.set(new Uint8Array(e.data), this.receiving.offset)
            }

            this.receiving.offset += chunkSize;
            this.files[this.receiving.index].offset += this.receiving.offset;
            this.files[this.receiving.index].file.size = this.receiving.size;
            this.files[this.receiving.index].progress = Math.round(100 * this.receiving.offset / this.receiving.size);


            if (this.receiving.offset === this.receiving.size) {
                if (this.serviceworker) {
                    this.serviceworker.postMessage({ id: this.receiving.id, type: 'end' })
                } else {
                    this.triggerDownload(this.receiving)
                }

                this.trackEvent('File', 'received', 'File received (kB)', Math.round(this.receiving.size / 10**3) );

                this.receiving = null
            }

        },

        triggerDownload (receiving) {
          if (this.serviceworker) {
            // `<a download=...>` doesn't work with service workers on Chrome yet.
            // See https://bugs.chromium.org/p/chromium/issues/detail?id=468227
            //
            // Possible solutions:
            //
            // - `window.open` is blocked as a popup.
            // window.open(`${SW_PREFIX}/${receiving.id}`);
            //
            // - And this is quite scary but `Content-Disposition` to the rescue!
            //   It will navigate to 404 page if there is no service worker for some reason...
            //   But if `postMessage` didn't throw we should be safe.
            window.location = `/_/${this.receiving.id}`
            console.log('receiving file with service worker')
          } else if (this.hacks.noblob) {
            console.log('receiving file using ios12 dataurl hack')
            const blob = new Blob([this.receiving.data], { type: this.receiving.type })
            const reader = new FileReader()
            reader.onloadend = () => {
              this.receiving.a.href = reader.result
              this.receiving.a.download = this.receiving.name
            }
            reader.readAsDataURL(blob)
          } else {
            const blob = new Blob([this.receiving.data], { type: this.receiving.type })
            this.receiving.a.href = URL.createObjectURL(blob)
            this.receiving.a.download = this.receiving.name
            this.receiving.a.click()
          }
        },

        async drop(e) {
            const source = e.dataTransfer ?? e.target; // drop or pick
            console.log("files dropped"+source.files)

            const droppedFiles = source.files;

            if (!droppedFiles)
                return;

            ([...droppedFiles]).forEach(async f => {

                let file = {
                    file: f,
                    size: f.size,
                    offset: 0,
                    sending: true,
                    progress: 0,
                }
                const length = this.files.push(file);
                const index = length-1;

                this.queue.push({f, index});

            });

            await this.handlePushFilesQueue();

            // would run async - dont want that
            // ([...droppedFiles]).forEach(async f => {
            //     await this.queue(f)
            // });

            // let files = e.dataTransfer.files;
            // for (let i = 0; i < files.length; i++) {
            //     await this.send(files[i]);
            // }
        },


        async connected() {
            this.info = 'Pripojené - presuň sem súbory na odoslanie:';
            this.isConnected = true;
            this.isDialling = false;
            this.showLink = false;
            this.qrUrl = null;
            this.connectionType = await getConnectionType(this.pc)
        },

        disconnected() {
            this.isConnected = false;
            this.isDialling = false;
            this.magiccode = null;
            this.showLink = false;
            this.connectionType = null;
            this.files = [];
            this.queue = [];
            this.queueWorking = false;
        },

        copyToClipboard() {
            this.info = "Odkaz bol skopírovaný"

            let testingCodeToCopy = document.querySelector('#link')
            testingCodeToCopy.setAttribute('type', 'text')
            testingCodeToCopy.select()

            document.execCommand('copy');
        },

        async handlePushFilesQueue() {

            if (this.queueWorking) {
                return
            }

            this.queueWorking = true;

            while (this.queue.length) {

                const {f, index} = this.queue.shift();

                await this.send(f, index);
            }

            this.queueWorking = false;
        },

        humanFileSize(size) {
            var i = size == 0 ? 0 : Math.floor( Math.log(size) / Math.log(1000) );
            return ( size / Math.pow(1000, i) ).toFixed(1) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
        },


        async swready() {
            if (!this.hacks.nosw) {
                const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/_/' })
                // TODO handle updates to service workers.
                this.serviceworker = registration.active || registration.waiting || registration.installing
                console.log('service worker registered:', this.serviceworker.state)
            }
        },

        async wasmready() {
          if (!this.hacks.nowasm) {
            const go = new Go()
            const wasm = await WebAssembly.instantiateStreaming(fetch('/util.wasm'), go.importObject)
            go.run(wasm.instance)
          }
        },


        browserhacks() {
            // Detect for features we need for this to work.
            if (!(window.WebSocket) ||
                !(window.RTCPeerConnection) ||
                !(window.WebAssembly)) {

                this.hacks.browserunsupported = true
                this.hacks.nosw = true
                this.hacks.nowasm = true
                console.log('quirks: browser not supported')
                console.log(
                    'websocket:', !!window.WebSocket,
                    'webrtc:', !!window.RTCPeerConnection,
                    'wasm:', !!window.WebAssembly
                    )
                return
            }

            // Polyfill for Safari WASM streaming.
            if (!WebAssembly.instantiateStreaming) {
                WebAssembly.instantiateStreaming = async (resp, importObject) => {
                    const source = await (await resp).arrayBuffer()
                    return await WebAssembly.instantiate(source, importObject)
                }
                console.log('quirks: using wasm streaming polyfill')
            }

            // Safari cannot save files from service workers.
            if (window.safari) {
                this.hacks.nosw = true
                console.log('quirks: serviceworkers disabled on safari')
            }

            if (true || !(navigator.serviceWorker)) {
                this.hacks.nosw = true
                console.log('quirks: no serviceworkers')
            }

            // Work around iOS Safari <= 12 not being able to download blob URLs.
            // This can die when iOS Safari usage is less than 1% on this table:
            // https://caniuse.com/usage-table
            this.hacks.noblob = false
            if (/^Mozilla\/5.0 \(iPhone; CPU iPhone OS 12_[0-9]_[0-9] like Mac OS X\)/.test(navigator.userAgent)) {
                this.hacks.noblob = true
                this.hacks.nosw = true
                console.log('quirks: using ios12 dataurl hack')
            }

            // Work around iOS trying to connect when the link is previewed.
            // You never saw this.
            if (/iPad|iPhone|iPod/.test(navigator.userAgent) &&
                ![320, 375, 414, 768, 1024].includes(window.innerWidth)) {
                this.hacks.noautoconnect = true
                console.log('quirks: detected preview, ')
            }

            // Detect for features we need for this to work.
            if (!(window.WebSocket) ||
                !(window.RTCPeerConnection) ||
                !(window.WebAssembly)) {
                this.hacks.browserunsupported = true
            }
        },

        trackEvent(category, action, label, value) {

            if (!this.$ga)
                return

            this.$ga.event(category, action, label, value)
        }

    },

    watch: {

        $route(to, from) {
            this.currentLocation = window.location.origin + this.$route.fullPath
            let qr = util.qrencode(this.currentLocation);
            console.log('generating RQ for '+this.currentLocation)
            this.qrUrl = URL.createObjectURL(new Blob([qr]))
        }
    },

    beforeRouteLeave (to, from, next) {

     if (this.magiccode) {

            this.$modal.show('dialog', {
              title: 'Kam ideš?',
              text: 'Odchodom z tejto stránky sa uzavrie tunel.',
              buttons: [
                {
                    title: 'Pokračovať',
                    handler: () => {
                        this.datachannel.close()
                        next()
                    }
                },
                {
                  title: 'Zachovať spojenie',
                  default: true,
                  class: 'vue-dialog-button font-bold'
                }
             ]
            })

            next(false)
            return
        }

        next()
    },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
